export default "__VITE_ASSET__fwHwPfmx__"